
function responsiveText() {
  let inputNewsletter = $(".input-newsletter > input");
  let placeholderLg = "Subscribe for insider offers"
  let placeholderXs = "Subscribe for insider offers"

  if ($(window).width() < 400) {
    inputNewsletter.attr("placeholder", placeholderXs);
  } else {
    inputNewsletter.attr("placeholder", placeholderLg);
  }
}

// AGREGAR EFECTOS DE ON SCROLL
$(window).on('load', function() {
  $('.element').attr('data-aos', 'fade-in-up');
  AOS.init();
});



$(window).scroll(function() {
  let x = $('.claudiana-help');
  let f = $('footer');
  
  let a = $(window).scrollTop();
  let b = $(window).height();
  let c = $(document).height();
  let d = $('footer').outerHeight();

  if (a + b  > c - d - 100) {
    f.addClass('is-visible');
  } else {
    f.removeClass('is-visible');
  }
});

$(document).ready(function() {
  let x = $('.claudiana-help');
  let f = $('footer');
  
  let a = $(window).scrollTop();
  let b = $(window).height();
  let c = $(document).height();
  let d = $('footer').outerHeight();

  if (a + b  > c - d - 100) {
    f.addClass('is-visible');
  } else {
    f.removeClass('is-visible');
  }
});

$(window).on('load resize', function() {
  responsiveText()
});

$(window).on('load', function() {
  $('.loader-component:after').fadeOut(1500);
  $('.loader-component').delay(1500).fadeOut('slow');
  $('main').css({
    opacity: 1,
  });

  var newsletter_cookie = checkCookie();

  if(newsletter_cookie){
    setTimeout(function () {
      $('.newsletter-modal').delay(1000).fadeIn('slow').addClass('is-open');
    }, 2000);
  }
  
});

$(document).ready(function() {
  var stepper = $('.input-stepper');
  stepper.inputStepper();

  MicroModal.init({
    disableScroll: true,
    disableFocus: true,
    awaitCloseAnimation: true,
  });
  
});

$('body').on('click', '[data-modal]', function() {
  var modalId = $(this).data('modal');
  $('body').addClass('body-no-scroll');
  $('.modal.is-open').removeClass('is-open');
  MicroModal.show(modalId);
  var stepper = $('#modal-cart .input-stepper');
  stepper.inputStepper();
});

$('body').on('click touchstart', '[data-micromodal-close], .modal .btn-close', function(){
  $('body').removeClass('body-no-scroll');
});

$('body').on('click', '[data-delete]', function() {
  $('.cart-order > .product-slim').hide();
  $('.cart-order > .cart-empty').addClass('d-flex');
});

 
$('body').on('click', '#modal-cart button.btn-close', function() {
  $('.modal.is-open').removeClass('is-open');
  $('#modal-cart').attr("aria-hidden", "true");
});

$('body').on('click', '.newsletter-modal .btn-close', function() {
  $('.newsletter-modal').removeClass('is-open');
});

$('body').on('click', '[data-wishlist]', function() {
  var add = 'Add to wishlist';
  var added = 'Added to wishlist!'

  if ($(this).attr('data-wishlist') == 'false') {
    $(this).text(added).attr('data-wishlist', 'true');

  } else if ($(this).attr('data-wishlist') == 'true') {
    $(this).text(add).attr('data-wishlist', 'false');
  }
});

$('body').on('click', '.collapse-item', function() {
  $(this).toggleClass('active').siblings('.active').removeClass('active');
});

$('body').on('click', '.product-spec h2 ', function() {
  $(this).toggleClass('active');
  var t = this.nextElementSibling;
  $(t).toggleClass('active');
});


$('body').on('click', '.list-sidebar > li', function(e) {
  $(this).addClass('active').siblings('.active').removeClass('active');

  if($(this).closest('#shopify-section-about--main')[0]){
    var target = $($('a', this).attr('href'));
    $("html, body").animate({scrollTop: target[0].offsetTop}, 300);
  }
});

$('body').on('click', '.account-warning', function() {
  $('[data-account-delete]').prop("disabled", false);
});

function showSuccess() {
  $('.form-wrapper').hide();
  $('.message-wrapper').show();
}

var currentHash = window.location.hash;




if ($('.claudiana-help, .claudiana-account').length > 0) {

  function clearActive() {
    $('.section-area').hide()
    $('.list-sidebar > li').removeClass('active');
    $(window).scrollTop(0)
  }

  function showContact() {
    clearActive();
    $('#help-contact').show();
    $('#nav-contact').addClass('active');
  }

  function showTerms() {
    clearActive();
    $('#help-terms').show();
    $('#nav-terms').addClass('active');
  }

  function showPrivacy() {
    clearActive();
    $('#help-privacy').show();
    $('#nav-privacy').addClass('active');
  }

  function showCookies() {
    clearActive();
    $('#help-cookies').show();
    $('#nav-cookies').addClass('active');
  }

  function showShipping() {
    clearActive();
    $('#help-shipping').show();
    $('#nav-shipping').addClass('active');
  }

  function showReturns() {
    clearActive();
    $('#help-returns').show();
    $('#nav-returns').addClass('active');
  }

  clearActive();


  if (currentHash == "") {
    showContact();
  }

  if (currentHash == "#contact") {
    showContact();
  }

  if (currentHash == "#terms") {
    showTerms();
  }

  if (currentHash == "#privacy") {
    showPrivacy();
  }

  if (currentHash == "#cookies") {
    showCookies();
  }

  if (currentHash == "#shipping") {
    showShipping();
  }

  if (currentHash == "#returns") {
    showReturns();
  }
}

if ($('.claudiana-login').length > 0) {
 

  function showLogin() {
    clearActive();
    $('#form-login').show();
  }

  function showPassword() {
    clearActive();
    $('#form-password').show();
  }

  function showSignup() {
    clearActive();
    $('#form-signup').show();
  }

  
}


if ($('.claudiana-account').length > 0) {

  function clearActive2() {
    $('.section-content').hide()
  }

  function showAccount() {
    clearActive2();
    $('#my-address').show();
    $('#nav-account').addClass('active');
  }

  function showWishlist() {
    clearActive2();
    $('#account-wishlist').show();
    $('#nav-wishlist').addClass('active');

  }

  function showOrders() {
    clearActive2();
    $('#account-orders').show();
    $('#nav-orders').addClass('active');
  }

  function showDelete() {
    clearActive2();
    $('#form-delete').show();
  }

  clearActive2();

  if (currentHash == "") {
    showAccount();
  }

  if (currentHash == "#wishlist") {
    showWishlist();
  }

  if (currentHash == "#account-orders") {
    showOrders();
  }

  if (currentHash == "#my-address") {
    showAccount();
  }

}

function shareFB() {
  u=location.href;t=document.title;window.open(
  'http://www.facebook.com/sharer.php?u='+encodeURIComponent(u)+'&t='+encodeURIComponent(t),
  'sharer','toolbar=0,status=0,width=626,height=436');return false;
}

function shareTW() {
  u=location.href;t=document.title;
  window.open(
    'http://twitter.com/share?text='+t,
    'share','toolbar=0,status=0,width=626,height=436');return false;
}

function sharePT(image) {
  u = location.href; t = document.title;window.open(
  'http://pinterest.com/pin/create/button?url='+encodeURIComponent(u)+'&media='+image+'&description='+ t,
  'sharer','toolbar=0,status=0,width=626,height=436');return false;
}


// Sidebar menu about
jQuery(document).ready(function(jQuery) {      
  var topMenu = jQuery("#shopify-section-about--main .section-sidebar .list-sidebar"),
      offset = 40,
      topMenuHeight = topMenu.outerHeight()+offset,
      menuItems =  topMenu.find('a[href*="#"]'),
      scrollItems = menuItems.map(function(){
        var href = jQuery(this).attr("href"),
        id = href.substring(href.indexOf('#')),
        item = jQuery(id);
        if (item.length) { return item; }
      });

  jQuery(window).scroll(function(){
    setTimeout(function() {
      var fromTop = jQuery(this).scrollTop()+topMenuHeight;
      var cur = scrollItems.map(function(){
        if (jQuery(this).offset().top < fromTop)
          return this;
      });
      cur = cur[cur.length-1];
      var id = cur && cur.length ? cur[0].id : "";               
  
      menuItems.parent().removeClass("active");
      if(id){
        menuItems.parent().end().filter("[href*='#"+id+"']").parent().addClass("active");
      }
    }, 600)

    if($(window).width() <= 320){
      var yOffset = window.pageYOffset;
      if(yOffset >= 25){
        $('header').addClass('bg-light');
      } else {
        $('header').removeClass('bg-light');
      }
    }

  })
});

$(function(){
  $('.newsletter-modal form').submit(function(e){
    setCookie("newsletter", 1, 5)
  })
})


  //VALIDACIÃ“N
  // $('form input').blur(function() {
  //   var e = this.nextElementSibling;
  //   if (!$(this).val()) {
  //     $(this).addClass('error').val('').css("border-color", "red");
  //     $(e).addClass('active');
  //   }
  // });
  $('form input').focus(function() {
    var e = this.nextElementSibling;
    if (!$(this).is('error')) {
      $(this).removeClass('error').css("border-color", "black");
      $(e).removeClass('active');
    }
  });

function setCookie(cname, cvalue, exdays) {
  var d = new Date();
  d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
  var expires = "expires="+d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
  var name = cname + "=";
  var ca = document.cookie.split(';');
  for(var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

function checkCookie() {
   
  var newsletter = getCookie("newsletter");
  if (newsletter != "") {
    return false
  }else{
    //setCookie("newsletter", 1, 5);
    return true
  }
}